import { Styles } from 'material-ui';
import * as Colors from 'components/Material/Styles/Colors';
const { Spacing } = Styles;

const styles = {
  root: {
    transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    position: 'relative',
    // minHeight: Spacing.desktopKeylineIncrement * 2,
    borderRadius: 2,
    border: `transparent solid 1px`
    // marginBottom: Spacing.desktopGutter,
  },
  edit: {
    borderRadius: 2,
    border: `solid 1px ${Colors.Colors.grey[300].material}`,
    backgroundColor: Colors.Colors.grey[100].material
  },
  hover: {
    backgroundColor: Colors.Colors.grey[100].material
  },

  dropZone: {
    // backgroundColor: Colors.Colors.grey[100].material,
    // borderColor: Colors.Colors.grey[300].material,
    // borderStyle: 'solid',
    // borderWidth: '1px',
    borderStyle: 'none',
    textAlign: 'center',
    padding: Spacing.desktopGutter,
    width: 'auto',
    height: 'auto',
    cursor: 'pointer'
  },
  icon: {
    verticalAlign: 'middle',
    margin: Spacing.desktopGutterMini,
    width: `${Spacing.desktopKeylineIncrement}px`,
    height: `${Spacing.desktopKeylineIncrement}px`
  },
  iconContainer: {
    padding: Spacing.desktopGutter
  },
  header: {
    fontSize: `28px`,
    fontWeight: 300
  },
  moduleContainer: {
    padding: Spacing.desktopGutterMini,
    textAlign: 'center'
  },
  toolbar: {
    // borderStyle: 'none none solid none',
    // borderWidth: 1,
    // borderColor: Colors.Colors.grey[300].material,
    backgroundColor: Colors.Colors.grey[200].material
  },
  seperator: {
    borderStyle: 'none solid none none',
    borderWidth: '1px',
    borderColor: Colors.Colors.grey[300].material
  },
  toolbarGroup: {
    margin: 2,
    borderRadius: 2,
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: Colors.Colors.grey[300].material
  },
  import: {
    root: {
      display: 'inline-block',
      backgroundColor: Colors.Colors.fullWhite,
      width: '100%'
    },
    input: {
      width: '100%',
      background: 'transparent',
      border: 'none',
      outline: 'none',
      padding: `0 ${Spacing.desktopGutterMini / 2}px`
    }
  },
  saving: {
    position: 'absolute',
    right: Spacing.desktopGutterMini / 2,
    bottom: Spacing.desktopGutterMini / 2,
    height: 50,
    width: 50
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/js/components/Page/Module/Styles.js